module.exports = __webpack_public_path__ + "static/img/exam-10-2-bg.82b63f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/exam-10-2-bg.png
// module id = Tyyo
// module chunks = 1